import { ValidationSchema } from '../../../../../../../validations/interfaces';
import { Validation } from '../../../../../../../validations/Validation';
import loanFormModel from '../../form_models/loanFormModel';
import * as Yup from 'yup';

const { beginInstallationExpected } = loanFormModel.formField;

export class BeginInstallationExpectedValidation implements ValidationSchema {
  public name = beginInstallationExpected.name;
  public label = beginInstallationExpected.label;
  public type = 'string';

  public required = {
    message: 'This field is required',
    value: true,
  };

  public nullable = true;
}
export default new Validation(new BeginInstallationExpectedValidation());
